module.exports = __webpack_public_path__ + "media/auto_data/check-off@3x-316fb7b7.svg";